import { bootstrapApplication } from '@angular/platform-browser';
import posthog from 'posthog-js';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { posthogOptions } from './app/core/error-handling/posthog-options';

// ─── PostHog init (browser only) ───────────────────────────────────
// Admin est du CSR pur (pas de SSR) — pas de garde isPlatformBrowser.
// Doit etre fait AVANT le bootstrap pour capturer les erreurs de demarrage.
// Reglages (masquage du replay, code/state OAuth, corps de requete) : `posthogOptions`.
//
// Si la cle est vide (local/test/prod avant cutover), `posthog.init` est skip —
// `TelemetryService.enabled` renverra false et tous les call sites deviennent no-op.
if (environment.posthogKey) {
  posthog.init(environment.posthogKey, posthogOptions(environment.posthogHost));
  posthog.register({
    // Distingue les events admin de la webapp dans le projet PostHog partage.
    app: 'admin',
    environment: environment.production ? 'production' : 'development',
    release: environment.appVersion,
  });
}

// Bootstrap-time fallback : LoggerService is unavailable before DI is wired,
// so a raw console.error is the only safe sink for catastrophic boot failures.
// eslint-disable-next-line no-console
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
